module.exports = __webpack_public_path__ + "prj_12.59c16ab1.jpeg";